import { createFileRoute, getRouteApi, redirect } from '@tanstack/react-router'
import { z } from 'zod'

import { AdminBroadcastsPage } from '@/features/admin-broadcasts'
// Through `queries`, not the feature index: a loader is eager by construction,
// and the index would bring the page and its table with it.
import { broadcastsPageQuery } from '@/features/admin-broadcasts/queries'
import { PERMISSION_ADMIN } from '@/features/auth'

import { can } from '@/app/router/session'

const searchSchema = z.object({
  page: z.number().int().min(0).default(0),
})

export const Route = createFileRoute('/_auth/admin/broadcasts')({
  beforeLoad: ({ context }) => {
    if (!can(context, PERMISSION_ADMIN)) throw redirect({ to: '/' })
  },
  validateSearch: searchSchema,
  // Declared before `loader`: the deps type is inferred from this in source
  // order, and below it the loader's `deps` is `{}`.
  loaderDeps: ({ search }) => ({ page: search.page }),
  // The page's data is fetched here rather than on mount. Mounting first is a
  // waterfall — chunk, then render, then request — and the page arrives in a
  // pending state it has to draw a placeholder for. `ensureQueryData` returns
  // the cached value when there is one, so this only waits the first time.
  loader: ({ context, deps }) =>
    context.queryClient.ensureQueryData(broadcastsPageQuery(deps.page)),
  component: AdminBroadcastsRoute,
})

const routeApi = getRouteApi('/_auth/admin/broadcasts')

function AdminBroadcastsRoute() {
  const { page } = routeApi.useSearch()
  const navigate = routeApi.useNavigate()

  return (
    <AdminBroadcastsPage
      page={page}
      onPageChange={(next) => void navigate({ search: (prev) => ({ ...prev, page: next }) })}
    />
  )
}
